// @ts-check
/* eslint-env browser */

/**
 * Gets all vector source names from the map style
 * @param {import('maplibre-gl').Map} map
 * @returns {string[]}
 */
function getVectorSourceNames (map) {
  const style = map.getStyle()
  const vectorSources = []

  if (style?.sources) {
    for (const [sourceName, source] of Object.entries(style.sources)) {
      if (
        source &&
        typeof source === 'object' &&
        'type' in source &&
        source.type === 'vector'
      ) {
        vectorSources.push(sourceName)
      }
    }
  }

  return vectorSources
}

/**
 * Gets all layer IDs that use vector sources (for querying features)
 * Returns fill layers first, then line layers
 * @param {import('maplibre-gl').Map} map - The MapLibre map instance
 * @param {{ fillOnly?: boolean }} [options] - Optional configuration
 * @returns {string[]} Array of layer IDs
 */
export function getVectorLayerIds (map, options) {
  const style = map.getStyle()
  const vectorSources = getVectorSourceNames(map)
  const fillLayerIds = []
  const lineLayerIds = []

  if (style?.layers) {
    for (const layer of style.layers) {
      if (
        'source' in layer &&
        layer.source &&
        typeof layer.source === 'string' &&
        vectorSources.includes(layer.source)
      ) {
        if (layer.type === 'fill') {
          fillLayerIds.push(layer.id)
        } else if (layer.type === 'line' && !options?.fillOnly) {
          lineLayerIds.push(layer.id)
        }
      }
    }
  }

  return [...fillLayerIds, ...lineLayerIds]
}
